import { render, staticRenderFns } from "./HelpLink.vue?vue&type=template&id=453f479b&scoped=true&"
import script from "./HelpLink.vue?vue&type=script&lang=js&"
export * from "./HelpLink.vue?vue&type=script&lang=js&"
import style0 from "./HelpLink.vue?vue&type=style&index=0&id=453f479b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453f479b",
  null
  
)

export default component.exports